/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteSectionsResponseData,
  GetSiteSectionsResponseDataFromJSON,
  GetSiteSectionsResponseDataFromJSONTyped,
  GetSiteSectionsResponseDataToJSON
} from './GetSiteSectionsResponseData'

/**
 *
 * @export
 * @interface GetSiteSectionsResponse
 */
export interface GetSiteSectionsResponse {
  /**
   *
   * @type {number}
   * @memberof GetSiteSectionsResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteSectionsResponseData}
   * @memberof GetSiteSectionsResponse
   */
  data?: GetSiteSectionsResponseData
}

export function GetSiteSectionsResponseFromJSON(json: any): GetSiteSectionsResponse {
  return GetSiteSectionsResponseFromJSONTyped(json, false)
}

export function GetSiteSectionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSiteSectionsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteSectionsResponseDataFromJSON(json['data'])
  }
}

export function GetSiteSectionsResponseToJSON(value?: GetSiteSectionsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteSectionsResponseDataToJSON(value.data)
  }
}
